import CombinedLabelValue from './CombinedLabelValue'
import OpenResponseBlock from './OpenResponseBlock'
import LabelValue from './LabelValue'

export default ({
  data = {}
}) => {
  const {
    // Top level data points
    // SF_OF_CODES_ACTIVATED__C: { value: ofCodesActivate } = {},
    // SF_OF_CODES_CONSUMED__C: { value: ofCodesConsumed } = {},
    // SF_TOTAL_STUDENTS: { value: totalStudents } = {},
    // SURVEY_FACILITATORS_POST_EXCITEMENT: { value: facilitatorsPostExcitement } = {},
    // SURVEY_SUMMER2025_TAGS_CHARACTER: { value: character } = {},
    // SURVEY_SUMMER2025_TAGS_FUN_ENGAGING: { value: funEngaging } = {},
    SURVEY_SUMMER2025_TAGS_FUN_JOY: { value: funJoy } = {},
    SURVEY_SUMMER2025_TAGS_CREATIVE_THINKING: { value: creativeThinking } = {},
    SURVEY_SUMMER2025_TAGS_CURIOSITY: { value: curiosity } = {},
    SURVEY_SUMMER2025_TAGS_SELF_MANAGEMENT: { value: selfManagement } = {},
    // SURVEY_STUDENT_TESTIMONIALS = [],
    SURVEY_STUDENT_TESTIMONIALS_TWO = [],
  } = data;

  // const hasValueIncludingZero = (value) =>   {
  //   return !(!value && value !== 0);
  // }

  // const ratioPlayingQuest = (hasValueIncludingZero(ofCodesActivate) && hasValueIncludingZero(ofCodesConsumed)) ? `${ofCodesActivate} / ${ofCodesConsumed}` : '-'

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '15px'
    }}>
      <div style={{
        color: '#565656',
        fontSize: '24px',
        fontWeight: 'bold',
        borderBottom: '1px solid #565656'
      }}>
        {'Core Data'}
      </div>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        padding: '5px',
        gap: '15px',
      }}>
        {/* <CombinedLabelValue
          label='students playing QUEST'
          value={totalStudents}
        /> */}
        <CombinedLabelValue
          label='of students ENGAGED and loving QUEST.'
          value={funJoy}
          isPercent={true}
        />
        {/* <CombinedLabelValue
          label='classes playing QUEST'
          value={ratioPlayingQuest}
        />
        <CombinedLabelValue
          label='of facilitators enjoying playing QUEST'
          value={facilitatorsPostExcitement}
          isPercent={true}
        /> */}
      </div>

      <div style={{
        color: '#565656',
        fontSize: '24px',
        fontWeight: 'bold',
        borderBottom: '1px solid #565656'
      }}>
        {'QUEST Builds Human Skills'}
      </div>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        padding: '5px',
        gap: '15px',
      }}>
        <LabelValue
          label='Creative Thinking'
          value={creativeThinking}
          isPercent={true}
        />
        <LabelValue
          label='Curiosity'
          value={curiosity}
          isPercent={true}
        />
        <LabelValue
          label='Self Management'
          value={selfManagement}
          isPercent={true}
        />
        {/* <CombinedLabelValue
          label='of students are ENGAGED'
          value={funEngaging}
          isPercent={true}
        />
        <CombinedLabelValue
          label='of students are fueled by CURIOSITY'
          value={curiosity}
          isPercent={true}
        />
        <CombinedLabelValue
          label='of students are building CHARACTER'
          value={character}
          isPercent={true}
        /> */}
      </div>

      <div style={{
        color: '#565656',
        fontSize: '24px',
        fontWeight: 'bold',
        borderBottom: '1px solid #565656'
      }}>
        {'Student Testimonials'}
      </div>

      <OpenResponseBlock
        header='Question: “What did you hear the kids say about QUEST today? Share quotes and funny moments!”'
        data={SURVEY_STUDENT_TESTIMONIALS_TWO}
      />

    </div>
  )
}